import {
  isMainPage,
  isSearchResult,
  isRefinePathOpenMobile,
} from "../helpers/urlParts";

export const isMainPageOpen = (state) => isMainPage(state.router.location.pathname);
export const isSearchPageOpen = (state) => isSearchResult(state.router.location.pathname);
export const isRefineOpenMobile = (state) => isRefinePathOpenMobile(state.router.location.pathname);



// WEBPACK FOOTER //
// ./src/selectors/router_selector.js